<template lang="pug" src="./smile-gallery.pug"></template>

<script>
import Gallery from 'custom/custom-smile-gallery/custom-smile-gallery'
import Hero from 'components/hero/hero-pages/hero-pages'

export default {
  computed: {
    props () {
      return this.$store.state.pages['smile-gallery']
    },
    loading () {
      return this.$store.state.loading
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('VIEW_NAV', false)
    next()
  },
  components: {
    Gallery,
    Hero
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/smile-gallery/smile-gallery.vue